var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 90,
    viewBox: "0 0 228 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 19,
    width: 12,
    height: 71,
    rx: 6,
    fill: "#76BA18"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 58,
    width: 12,
    height: 32,
    rx: 6,
    fill: "#76BA18"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    width: 12,
    height: 90,
    rx: 6,
    fill: "#76BA18"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 72,
    width: 12,
    height: 18,
    rx: 6,
    fill: "#76BA18"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 36,
    width: 12,
    height: 54,
    rx: 6,
    fill: "#76BA18"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 58,
    width: 12,
    height: 32,
    rx: 6,
    fill: "#76BA18"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 58,
    width: 12,
    height: 32,
    rx: 6,
    fill: "#76BA18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioEmpty);
export default __webpack_public_path__ + "static/media/audio-empty.116b712c.svg";
export { ForwardRef as ReactComponent };